import React, { PureComponent } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, reset, touch, focus } from 'redux-form';

import * as templateLib from 'libs/attachLib';
import * as templateActions from 'modules/templateAttach';

import { ExamAttachEdit } from 'components';

class CtExamAttachEdit extends PureComponent {
  constructor(props) {
    super(props);

    //this.checkFieldCount = 0;
    this.state = {
      onProgress: true
    };
  }

  componentWillReceiveProps(nextProps) {
    const { invalid, editSaveNow, setEditInvalid, setDisableSave } = this.props;
    const { formStore } = nextProps;

    if (invalid !== nextProps.invalid && typeof setEditInvalid === 'function') {
      setEditInvalid(nextProps.invalid);
    }

    if (nextProps.editSaveNow && nextProps.editSaveNow !== editSaveNow) {
      if (nextProps.invalid) {
        if (typeof setDisableSave === 'function') {
          setDisableSave(true);
        }
        this.markFieldValidate('examAttachEdit');
      } else {
        this.saveTemplate();
      }
    }

    if (formStore && formStore.fields) {
      const errorType = ['syncErrors', 'syncWarnings', 'asyncErrors', 'asyncWarnings'];

      let anyError = false;
      for (const field in formStore.fields) {
        if (
          formStore.fields.hasOwnProperty(field) &&
          formStore.fields[field].touched &&
          formStore.fields[field].visited &&
          formStore.registeredFields[field] &&
          formStore.registeredFields[field].count > 0
        ) {
          for (let i = 0, l = errorType.length; i < l; i++) {
            if (formStore[errorType[i]] && formStore[errorType[i]][field]) {
              anyError = true;
              if (typeof setDisableSave === 'function') {
                setDisableSave(true);
              }
              break;
            }
          }
        }
        if (anyError) {
          break;
        }
      }

      if (!anyError) {
        if (typeof setDisableSave === 'function') {
          setDisableSave(false);
        }
      }
    }
  }

  markFieldValidate = formName => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  saveTemplate = async () => {
    const { invalid, setEditOnProgress } = this.props;

    if (typeof setEditOnProgress === 'function') {
      setEditOnProgress(true);
    }
    this.setState({ onProgress: true });

    if (!this.props.invalid) {
      const { isAuth, formStore, invalid, templateInfo, TemplateActions, handleOnToggleEditModal } = this.props;

      const params = {};
      if (formStore && formStore.values && formStore.registeredFields) {
        for (const field in formStore.registeredFields) {
          if (formStore.registeredFields.hasOwnProperty(field)) {
            if (formStore.registeredFields[field].count > 0) {
              if (typeof formStore.values[field] !== 'undefined' && formStore !== templateInfo) {
                params[field] = formStore.values[field];
              }
            }
          }
        }
      }

      let preparedParams = false;
      if (Object.keys(params).length > 0) {
        if (!!!templateInfo) {
          if (isAuth === 2) {
            params.attachInfoNo = templateInfo.attachInfoNo;
            preparedParams = true;
          }
        } else {
          params.attachInfoNo = templateInfo.attachInfoNo;
          preparedParams = true;
        }
      }

      if (preparedParams) {
        //
        try {
          await TemplateActions.updateAttach(params);
        } catch (e) {
          console.log(e);
        }
      } else {
        // 업데이트 할 것이 없음
      }
      handleOnToggleEditModal();
    } else {
      // invalid
    }
  };

  handleOnOpenEditModal = () => {
    const { setEditOnProgress } = this.props;

    if (typeof setEditOnProgress === 'function') {
      setEditOnProgress(false);
    }
    this.setState({ onProgress: false });
  };

  render() {
    const { onProgress } = this.state;
    const { addMode, isAuth, formStore, invalid, templateInfo, handleOnToggleEditModal } = this.props;
    const { handleOnOpenEditModal, saveTemplate } = this;

    return (
      <ExamAttachEdit
        addMode={addMode}
        isAuth={isAuth}
        onProgress={onProgress}
        formStore={formStore}
        invalid={invalid}
        templateInfo={templateInfo}
        handleOnOpenEditModal={handleOnOpenEditModal}
        handleOnToggleEditModal={handleOnToggleEditModal}
        saveTemplate={saveTemplate}
      />
    );
  }
}

CtExamAttachEdit.propTypes = {};
CtExamAttachEdit.defaultProps = {};

const mapStateToProps = (state, props) => {
  const { templateInfo } = props;

  return {
    initialValues: templateInfo,
    formStore: state.form['examAttachEdit'],
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'examAttachEdit',
    enableReinitialize: true,
    touchOnChange: true
  })(CtExamAttachEdit)
);



// WEBPACK FOOTER //
// ./src/script/containers/examAttach/CtExamAttachEdit_origin.js